/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationDevice } from '../../models/location-device';

export interface GetDevicePageLocationData$Params {
  facilityId?: number;
}

export function getDevicePageLocationData(http: HttpClient, rootUrl: string, params?: GetDevicePageLocationData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationDevice>>> {
  const rb = new RequestBuilder(rootUrl, getDevicePageLocationData.PATH, 'get');
  if (params) {
    rb.query('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocationDevice>>;
    })
  );
}

getDevicePageLocationData.PATH = '/api/regdevice/full/location';
